module.exports = __webpack_public_path__ + "img/123.fa9116ce.jpg";